import { useHistory, useLocation } from "react-router-dom";
import { tourOpened } from "explorer/reducers/users";
import { useDispatch } from "react-redux";
import { useState, useRef, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm-horizontal.svg";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Tour_Variant_A } from "shared/constants/TourConst";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import "./Welcome.scss";
const DEFAULT_VARIANT = Tour_Variant_A;

type WelcomeProps = {
  show: boolean;
};

const Welcome: React.FC<WelcomeProps> = ({ show }) => {
  const dispatch = useDispatch();
  const [playingVideo, setPlayingVideo] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const history = useHistory<any>();
  const { t } = useTranslation();
  const { tourVariant } = useFlags();
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const variant = params.get("variant");
  const resolvedVariant = variant || tourVariant || DEFAULT_VARIANT;

  const onEndVideo = () => {
    dispatch(tourOpened());

    history.push({
      pathname: "/home",
      search: search || "",
    });
  };

  useEffect(() => {
    if (show) {
      videoRef?.current?.load();
      dataLayerViewedEvent({
        ...tagManagerEvent.Tour.ONBOARDING_WELCOME,
        ABTest: resolvedVariant === Tour_Variant_A ? "FLOW_A" : "FLOW_B",
      });
    }
  }, [resolvedVariant, show]);

  return (
    <div
      style={{
        display: show ? "block" : "none",
      }}
      className={`welcome-container ${isMobile ? "mobile" : ""}`}
    >
      <video
        muted
        playsInline
        className="video-background"
        onEnded={onEndVideo}
        ref={videoRef}
        src="/clip-tour-hq.mp4"
        poster="/clip-tour-poster.jpg"
        preload="auto"
      ></video>
      <div className="overlay" />
      <div
        className="video-overlay-content"
        style={{
          opacity: playingVideo ? 0 : 1,
          visibility: playingVideo ? "hidden" : "visible",
          transition: "opacity 0.5s ease-in-out, visibility 0.5s ease-in-out",
        }}
      >
        <div className="welcome-logo">
          <p>
            <span className="color-light-lavender">
              {t("pages.Tour.welcome")}
            </span>
            <br />
            <Logo />
          </p>
          <p className="title-unlock">{t("pages.Tour.unlockAllBenefits")}</p>
          <p className="subtile-unlock color-light-lavender">
            {t("pages.Tour.getYourMusicOutThere")}
          </p>
        </div>
        <div className="welcome-action-container">
          <button
            className="botao-azul btn-forward btn-welcome"
            onClick={() => {
              setPlayingVideo(true);
              videoRef.current?.play();
            }}
          >
            {t("pages.Tour.letsGo")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
